<template>
  <div class="out-cont">
    <div class="fake-header" style="height: 80px;width: 100%; background: #218BEF"></div>
    <div class="content">
      <div class="guide-header">
        <img src="../../static/img/intelligent/robort.png" alt="">
        <div class="chinese-title">业务办理智能引导</div>
      </div>
      <div class="guide" >
        <div class="guide-title">请选择办事情形</div>
        <div class="guide-wrap">
          <div class="guide-item">
            <div class="guide-icon guide-icon-active"></div>
            <div class="guide-line-bottom"></div>
            <div class="guide-cont">
              <div class="cont-title">1.请选择培训机构营利类型：</div>
              <div class="btn-group">
                <div class="btn active">非营利性培训机构</div>
                <div class="btn">营利性培训机构</div>
              </div>
            </div>
          </div>
          <div class="guide-item">
            <div class="guide-icon guide-icon-active"></div>
            <div class="guide-line-top"></div>
            <div class="guide-line-bottom"></div>
            <div class="guide-cont">
              <div class="cont-title">2.请选择举办者类型：</div>
              <div class="btn-group">
                <div class="btn active">社会组织</div>
                <div class="btn">个人</div>
              </div>
            </div>
          </div>
          <div class="guide-item">
            <div class="guide-icon guide-icon-active"></div>
            <div class="guide-line-top"></div>
            <div class="guide-line-bottom"></div>
            <div class="guide-cont">
              <div class="cont-title">3.请选择办学场所类型</div>
              <div class="btn-group">
                <div class="btn active">自有场所举办</div>
                <div class="rominfo">
                  <label class="radio-inline">
                    <input type="radio" name="handleTypeOptions" checked="">已办理房屋产权证
                  </label>
                  <label class="radio-inline">
                    <input type="radio" name="handleTypeOptions" checked="">未办理房屋产权证
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="guide-item">
            <div class="guide-icon guide-icon-active"></div>
            <div class="guide-line-top"></div>
            <div class="guide-line-bottom"></div>
            <div class="guide-cont">
              <div class="cont-title">4.请问是否有在线培训业务？</div>
              <div class="rominfo">
                <label class="radio-inline">
                  <input type="radio" name="handleTypeOptions" checked="">是
                </label>
                <label class="radio-inline">
                  <input type="radio" name="handleTypeOptions" checked="">否
                </label>
              </div>
            </div>
          </div>
          <div class="guide-item">
            <div class="guide-icon"></div>
            <div class="guide-line-top"></div>
            <div class="guide-cont">
              <div class="cont-title">5.请选择办学形式</div>
              <div class="btn-group">
                <div class="btn">联合办学（两个以上举办者联合举办）</div>
                <div class="btn">单独举办</div>
              </div>
            </div>
          </div>
        </div>
        <div class="guide-btn" @click="openNewPage('https://www.gdzwfw.gov.cn/portal/v2/guide/1144010607844173874440102008001')">生成您的专属办事指南</div>
      </div>
    </div>
  </div>
</template>
<script src="../../static/js/vendor/jquery/jquery.min.js"></script>
<script src="../../static/js/vendor/bootstrap/bootstrap.min.js"></script>
<script src="../../static/js/vendor/swiper/swiper-bundle.min.js"></script>
<script src="../../static/js/nicescroll.min.js"></script>
<!-- Global  -->
<script src="../../static/js/global.js"></script>
<script src="../../static/js/common.js"></script>
<!-- Page -->
<script src="../../static/js/index.js"></script>

<script>
export default {
  name: "Intelligent",
  methods: {
    openNewPage(url) {
      window.open(url)
    }
  }
}
</script>

<style scoped>
@import '../../static/css/intelligent.css';
</style>



// WEBPACK FOOTER //
// Intelligent.vue?6be30254